import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import HelperPriceService from "app/apis/Goeasy/HelperPrice/HelperPriceService";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import { PrimaryButton } from "app/components/Buttons/Button";
import { ErrorToaster, SuccessToaster } from "app/components/Toaster/Toaster";
import { InputField } from "app/components/UI/TextField";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

function AssistancePrice() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm();

  const [loader, setLoader] = useState(true);
  const handleDataSubmission = async (formData) => {
    try {
      let { message } = await HelperPriceService.createPrice(formData);
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getPrice = async () => {
    try {
      let { data } = await HelperPriceService.getPrice();
      setValue("price", data?.pop()?.price);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getPrice();
  }, []);

  return (
    <Layout>
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Assistance Pricing
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Assistance Pricing" />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, bgcolor: colors.white, p: 2, borderRadius: 4 }}>
          {loader ? (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress color="success" />
            </Box>
          ) : (
            <Box component="form" onSubmit={handleSubmit(handleDataSubmission)}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <InputField
                    type={"number"}
                    label="Assistance Price"
                    error={errors?.price?.message}
                    // defaultValue={}
                    register={register("price", {
                      required: "Price is required",
                      min: {
                        value: 0,
                        message: "Price cannot be less than 0",
                      },
                      max: {
                        value: 100000,
                        message: "Price cannot be more than 100000",
                      },
                    })}
                  />
                </Grid>
              </Grid>

              {/* ================= Submit ================= */}
              <PrimaryButton
                loading={isSubmitting}
                type="submit"
                title="Save"
                myStyle={{ mt: 2, borderRadius: 2 }}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default AssistancePrice;
